import { Box, Grid, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import { Paper, styled } from "@mui/material";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import EditIcon from "@mui/icons-material/Edit";
// import { Pie, PieChart } from "recharts";
import { PieChart } from '@mui/x-charts/PieChart';
import { ResponsivePie } from "@nivo/pie";
import config from "../../../Data/AuthUser";
import { clientApis, clientDriversApis } from "../../../Data/axios";
const DetailsClients = () => {
  const navigate = useNavigate();
  const [detailValue, setDetailValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Mobile number edit states
  const [openMobileEdit, setOpenMobileEdit] = useState(false);
  const [newMobileNumber, setNewMobileNumber] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [driversData, setDriversData] = useState([]);
  const [driversLoading, setDriversLoading] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  
  // Use ID from URL params if available, otherwise fall back to location state
  const openMenuId = id || location.state;
  const openDropMenu = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  
  const handleEdit = {};

  // Mobile number edit handlers
  const handleOpenMobileEdit = () => {
    setNewMobileNumber(phone || "");
    setMobileError("");
    setOpenMobileEdit(true);
  };

  const handleCloseMobileEdit = () => {
    setOpenMobileEdit(false);
    setNewMobileNumber("");
    setMobileError("");
  };

  const handleSaveMobile = async () => {
    // Validate mobile number
    if (!newMobileNumber || newMobileNumber.trim() === "") {
      setMobileError("Mobile number is required");
      return;
    }

    // Remove any non-digit characters for validation
    const cleanNumber = newMobileNumber.replace(/\D/g, '');

    // Validate 12-digit number starting with 91
    if (!/^91\d{10}$/.test(cleanNumber)) {
      setMobileError("Please enter a valid 12-digit mobile number starting with 91");
      return;
    }

    try {
      // Call the API to update the mobile number
      await clientApis.updateClientMobileNumber(user_id, cleanNumber);

      // Update the local data to reflect the change
      if (detailValue && detailValue.app_user) {
        detailValue.app_user.phone = cleanNumber;
        setDetailValue({ ...detailValue });
      }

      // Close the dialog immediately after successful update
      handleCloseMobileEdit();
    } catch (error) {
      console.error("Error updating mobile number:", error);
      setMobileError(
        error.response?.data?.message || "Failed to update mobile number. Please try again."
      );
    }
  };
  
  useEffect(() => {
    console.log("DetailsClients useEffect triggered");
    console.log("id from useParams:", id);
    console.log("location.state:", location.state);
    console.log("openMenuId:", openMenuId);

    if (openMenuId) {
      getData();
      getDriversData();
    } else {
      setError("No client ID found in URL params or location state");
      setLoading(false);
      console.error("No client ID found in URL params or location state");
    }
  }, [openMenuId]);
  
  const getData = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log("Fetching client data for user_id:", openMenuId);
      console.log("Type of openMenuId:", typeof openMenuId);
      console.log("openMenuId value:", JSON.stringify(openMenuId));

      // Use clientViewMoreId with the user_id (RPTPLCLNT format)
      const rowData = await clientApis.clientViewMoreId(openMenuId);
      console.log("Client data received:", rowData);
      setDetailValue(rowData);
    } catch (error) {
      console.error("Error fetching client data:", error);
      console.error("Error response:", error.response);
      console.error("Error status:", error.response?.status);
      console.error("Error data:", error.response?.data);

      let errorMessage = 'Unknown error';
      if (error.response?.status === 404) {
        errorMessage = `Client with user_id "${openMenuId}" not found. Please check if the user_id is correct.`;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      setError(`Failed to load client data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const getDriversData = async () => {
    try {
      setDriversLoading(true);
      console.log("Fetching drivers data for client:", user_id);

      // Use the clientDriversApis.getClientDriversList API
      const response = await clientDriversApis.getClientDriversList(user_id);
      console.log("Drivers API response:", response);

      if (response.success && response.data) {
        // Filter drivers with status = 1 only
        const activeDrivers = Array.isArray(response.data)
          ? response.data.filter(driver => driver.Status === 1 || driver.status === 1)
          : [];

        console.log("Active drivers (status = 1):", activeDrivers);
        setDriversData(activeDrivers);
      } else {
        console.error("Failed to fetch drivers:", response.message);
        setDriversData([]);
      }
    } catch (error) {
      console.error("Error fetching drivers data:", error);
      setDriversData([]);
    } finally {
      setDriversLoading(false);
    }
  };

  // Show loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Loading client details for ID: {openMenuId}...</div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <div className="text-lg text-red-600 mb-4">Error: {error}</div>
        <button 
          onClick={() => navigate('/clients')}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Back to Clients
        </button>
      </div>
    );
  }

  // Show empty state if no data
  if (!detailValue) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <div className="text-lg mb-4">No client data found</div>
        <button 
          onClick={() => navigate('/clients')}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Back to Clients
        </button>
      </div>
    );
  }
  const {
    total_drivers,
    app_user,
    client,
    active_drivers_count,
    inactive_drivers_count,
    leave_drivers_count,
    total_earnings,
    due_invoice,
    total_invoice,
    paid_invoice,
    partial_invoice,
  } = detailValue || {};

  const {
    Status,
    address,
    created_at,
    gender,
    image,
    language,
    phone,
    username,
    pincode,
    email,
    state: user_state,
  } = app_user || {};
  const {
    allow_login,
    company_website,
    company_email,
    company_name,
    industry_type,
    tax_name,
    tax_number,
    user_id,
    state,
    company_phone,
    company_address,
    last_login,
    note,
  } = client || {};
  // const convertToPlainText = (htmlContent) => {
  //   const parser = new DOMParser();
  //   const parsedHtml = parser.parseFromString(htmlContent, "text/html");
  //   return parsedHtml.body.textContent || "";
  // };
  // {convertToPlainText(description)}
  const date = new Date(created_at);

  // Extract the day, month, and year from the Date object
  const day = String(date.getDate()).padStart(2, "0"); // Adds leading zero if necessary
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
  const year = date.getFullYear();

  // Format the date as "DD-MM-YYYY"
  const formattedDate = `${day}-${month}-${year}`;

  // async function handleEdit=()=> {

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const convertToMainUserType = (value) => {
    if (value === "1") return "Male";
    if (value === "2") return "Female";
    if (value === "3") return "Others";

    return "Unknown"; // Fallback for invalid values
  };

  return (
    <>
      {/* <Box sx={{ bgcolor: "#eff1f1", height: "100%", width: "100%" }}>
        <Grid
          container
          sx={{
            width: "100%",
            paddingBottom: "15px",
            display: "flex",
            // justifyContent: "space-evenly",
            alignItems: "center",
            flex: 1,
            gap: 3,
          }}
        >
          <Grid item xs={11} sm={6} md={3.5} lg={3.5}>
            <Item
              sx={{
                backgroundColor: "#fff",
                color: "#333",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                padding: "20px",
                bgcolor: "#fff",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <img
                  src={`${config.apiImageUrl}${image}`}
                  alt="Picture not found"
                  style={{ height: "70px", width: "70px", borderRadius: "7px" }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <Box>{username}</Box>
                  <Box>{company_name}</Box>
                  <Box>{last_login}</Box>
                </Box>
              </Box>
              <Box>
                <MoreHorizTwoToneIcon />
              </Box>
              {/* <Box>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  sx={{ marginRight: "40px" }}
                  onClick={handleClick}
                >
                  <MoreHorizTwoToneIcon />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleEdit()}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <EditNoteIcon /> Edit
                    </div>
                  </MenuItem>
                </Menu>
              </Box> 
            </Item>
          </Grid>
          <Grid item xs={11} sm={6} md={2.5} lg={2.5}>
            <Item sx={{ backgroundColor: "#fff", color: "#333" }}>
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                Total Drivers
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "right" }}
              >
                <LocalActivityIcon sx={{ color: "#a7adad " }} />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontSize: "16px",
                  color: "#1d82f5",
                  fontWeight: 550,
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                {total_drivers}
              </Typography>
            </Item>
          </Grid>
          <Grid item xs={11} sm={6} md={2.5} lg={2.5}>
            <Item sx={{ backgroundColor: "#fff", color: "#333" }}>
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                Total Earnings
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "right" }}
              >
                <LocalActivityIcon sx={{ color: "#a7adad " }} />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontSize: "16px",
                  color: "#1d82f5",
                  fontWeight: 550,
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                {total_earnings}
              </Typography>
            </Item>
          </Grid>
          <Grid item xs={11} sm={6} md={2.5} lg={2.5}>
            <Item sx={{ backgroundColor: "#fff", color: "#333" }}>
              <Typography
                gutterBottom
                variant="subtitle1"
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                Due Invoices
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                style={{ textAlign: "right" }}
              >
                <LocalActivityIcon sx={{ color: "#a7adad " }} />
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontSize: "16px",
                  color: "#1d82f5",
                  fontWeight: 550,
                  textAlign: "left",
                  paddingLeft: "20px",
                }}
              >
                {due_invoice}
              </Typography>
            </Item>
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", gap: 2, height: "650px" }}>
          <Grid
            item
            xs={11}
            sm={11}
            md={7.2}
            lg={7.2}
            sx={{
              color: "#333",
              // padding: "20px",
              fontSize: "20px",
              fontWeight: 550,
              // width: "60%",
              bgcolor: "#fff",
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid rgb(187, 186, 186) ",
              }}
            >
              <Box sx={{ padding: "10px 20px" }}>Profile Info</Box>
            </Box>
            <Box>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Full Name
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {username}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    Logo
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Email
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {company_email}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Company Name
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {company_name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Time
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {formattedDate}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Mobile
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {phone}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Gender
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {convertToMainUserType(gender)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Office Phone Number
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {company_phone}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Official Website
                  </Typography>
                </Grid>

                <Grid item xs={8}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {company_website}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    GST/VAT Number
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {tax_number}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Address
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {address}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    State
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {state}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Postal code
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {pincode}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      padding: "10px 20px",
                      fontSize: "15px",
                    }}
                  >
                    Language
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "gray",
                      padding: "10px 0",
                      fontSize: "15px",
                    }}
                  >
                    {language}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4.5}
            lg={4.5}
            sx={{
              display: "flex",
              flexDirection: "column",
              // width: "40%",
              gap: 2,
              height: "100%",
            }}
          >
            <Box
              sx={{
                height: "50%",
                width: "100%",
                bgcolor: "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Item
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      backgroundColor: "#fff",
                      color: "#000",
                    }}
                  >
                    <Typography sx={{ fontSize: "20px", fontWeight: 550 }}>
                      Drivers
                    </Typography>
                    <PieChart width={400} height={270}>
                      <Pie
                        data={[
                          {
                            name: "Active",
                            value: (active_drivers_count * 100) / 3,
                            fill: "#C70039",
                          },
                          {
                            name: "Inactive",
                            value: (inactive_drivers_count * 100) / 3,
                            fill: "#FFC300",
                          },
                          {
                            name: "Leave",
                            value: (leaveDrivers_count * 100) / 3,
                            fill: "#FF5733",
                          },
                        ]}
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} (${(percent * 100).toFixed(0)}%)`
                        }
                        labelStyle={{
                          fill: "#333", // Set label color to black
                          fontSize: "14px", // Adjust font size
                        }}
                        outerRadius={80}
                      />
                    </PieChart>
                  </Item>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                height: "50%",
                width: "100%",
                bgcolor: "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <Item
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      backgroundColor: "#fff",
                      color: "#000",
                    }}
                  >
                    <Typography sx={{ fontSize: "20px", fontWeight: 550 }}>
                      Invoices
                    </Typography>
                    <PieChart width={400} height={270}>
                      <Pie
                        data={[
                          {
                            name: "unpaid",
                            value: (due_invoice * 100) / 3,
                            fill: "#FFC300",
                          },
                          {
                            name: "paid",
                            value: (paid_invoice * 100) / 3,
                            fill: "#C70039 ",
                          },
                          {
                            name: "partial",
                            value: (partial_invoice * 100) / 3,
                            fill: "#FF5733",
                          },
                        ]}
                        dataKey="value"
                        label={({ name, percent }) =>
                          `${name} (${(percent * 100).toFixed(0)}%)`
                        }
                        labelStyle={{
                          fill: "#333", // Set label color to black
                          fontSize: "14px", // Adjust font size
                        }}
                        outerRadius={80}
                      />
                    </PieChart>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box> */}



<div className="grid grid-cols-6 grid-rows-10 text-black gap-4">
    <div className="col-span-2 row-span-2">
      <div className="max-w-md p-8 sm:flex sm:space-x-6 bg-gray-50 text-gray-800">
	<div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
		<img 
		  src={
		    image && image !== "non" 
		      ? `${config.apiImageUrl}${image}` 
		      : "https://source.unsplash.com/100x100/?portrait?1"
		  } 
		  alt="" 
		  className="object-cover object-center w-full h-full rounded bg-gray-500" 
		/>
	</div>
	<div className="flex flex-col space-y-4">
		<div>
			<h2 className="text-2xl font-semibold">{username}</h2>
			<span className="text-sm text-gray-600">{user_id}</span>
		</div>
		<div className="space-y-1">
			<span className="flex items-center space-x-2">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-label="Email address" className="w-4 h-4">
					<path fill="currentColor" d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"></path>
				</svg>
				<span className="text-gray-600">{company_email}</span>
			</span>
			<span className="flex items-center space-x-2">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-label="Phonenumber" className="w-4 h-4">
					<path fill="currentColor" d="M449.366,89.648l-.685-.428L362.088,46.559,268.625,171.176l43,57.337a88.529,88.529,0,0,1-83.115,83.114l-57.336-43L46.558,362.088l42.306,85.869.356.725.429.684a25.085,25.085,0,0,0,21.393,11.857h22.344A327.836,327.836,0,0,0,461.222,133.386V111.041A25.084,25.084,0,0,0,449.366,89.648Zm-20.144,43.738c0,163.125-132.712,295.837-295.836,295.837h-18.08L87,371.76l84.18-63.135,46.867,35.149h5.333a120.535,120.535,0,0,0,120.4-120.4v-5.333l-35.149-46.866L371.759,87l57.463,28.311Z"></path>
				</svg>
				<span className="text-gray-600">+91 {company_phone}</span>
			</span>
		</div>
	</div>
</div>
</div>
    <div className="col-span-4 row-span-2 col-start-3">
      <section className="p-6 my-6  text-gray-800">
	<div className="container grid grid-cols-1 gap-6 mx-auto sm:grid-cols-2 xl:grid-cols-3">
		<div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
			<div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="h-9 w-9 text-gray-100">
					<polygon points="160 96.039 160 128.039 464 128.039 464 191.384 428.5 304.039 149.932 304.039 109.932 16 16 16 16 48 82.068 48 122.068 336.039 451.968 336.039 496 196.306 496 96.039 160 96.039"></polygon>
					<path d="M176.984,368.344a64.073,64.073,0,0,0-64,64h0a64,64,0,0,0,128,0h0A64.072,64.072,0,0,0,176.984,368.344Zm0,96a32,32,0,1,1,32-32A32.038,32.038,0,0,1,176.984,464.344Z"></path>
					<path d="M400.984,368.344a64.073,64.073,0,0,0-64,64h0a64,64,0,0,0,128,0h0A64.072,64.072,0,0,0,400.984,368.344Zm0,96a32,32,0,1,1,32-32A32.038,32.038,0,0,1,400.984,464.344Z"></path>
				</svg>
			</div>
			<div className="flex flex-col justify-center align-middle">
				<p className="text-3xl font-semibold leading-none">{active_drivers_count || 0}</p>
				<p className="capitalize">Active Drivers</p>
			</div>
		</div>
		<div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
			<div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="h-9 w-9 text-gray-100">
					<path d="M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM403.078,403.078a207.253,207.253,0,1,1,44.589-66.125A207.332,207.332,0,0,1,403.078,403.078Z"></path>
					<path d="M256,384A104,104,0,0,0,360,280H152A104,104,0,0,0,256,384Z"></path>
					<polygon points="205.757 228.292 226.243 203.708 168 155.173 109.757 203.708 130.243 228.292 168 196.827 205.757 228.292"></polygon>
					<polygon points="285.757 203.708 306.243 228.292 344 196.827 381.757 228.292 402.243 203.708 344 155.173 285.757 203.708"></polygon>
				</svg>
			</div>
			<div className="flex flex-col justify-center align-middle">
				<p className="text-3xl font-semibold leading-none">₹{total_earnings || 0}</p>
				<p className="capitalize">Total Earnings</p>
			</div>
		</div>
		<div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
			<div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="h-9 w-9 text-gray-100">
					<path d="M425.706,142.294A240,240,0,0,0,16,312v88H160V368H48V312c0-114.691,93.309-208,208-208s208,93.309,208,208v56H352v32H496V312A238.432,238.432,0,0,0,425.706,142.294Z"></path>
					<rect width="32" height="32" x="80" y="264"></rect>
					<rect width="32" height="32" x="240" y="128"></rect>
					<rect width="32" height="32" x="136" y="168"></rect>
					<rect width="32" height="32" x="400" y="264"></rect>
					<path d="M297.222,335.1l69.2-144.173-28.85-13.848L268.389,321.214A64.141,64.141,0,1,0,297.222,335.1ZM256,416a32,32,0,1,1,32-32A32.036,32.036,0,0,1,256,416Z"></path>
				</svg>
			</div>
			<div className="flex flex-col justify-center align-middle">
				<p className="text-3xl font-semibold leading-none">{due_invoice || 0}</p>
				<p className="capitalize">Due Invoices</p>
			</div>
		</div>
	</div>
</section>
    </div>
    <div className="col-span-4 row-span-8 row-start-3 bg-white">
      <div className="container p-2 mx-auto sm:p-4 text-gray-800">
	<h2 className="mb-4 text-2xl font-semibold leading-tight">Client Info</h2>
	<div className="flex flex-col overflow-x-auto text-md">
		<div className="flex border-b border-opacity-20 border-gray-300 ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Full Name</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{username}</div>
		</div>
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Email</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{email || company_email}</div>
		</div>
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Company Name</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{company_name}</div>
		</div>
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Time</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{formattedDate}</div>
		</div>
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Mobile</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto flex items-center gap-2">
				{phone}
				<EditIcon
					sx={{
						fontSize: "1rem",
						cursor: "pointer",
						color: "#1976d2",
						"&:hover": { color: "#115293" }
					}}
					onClick={handleOpenMobileEdit}
				/>
			</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Gender</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{convertToMainUserType(gender)}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Office Phone Number</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{company_phone}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Official Website</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{company_website}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>GST/VAT Number</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{tax_number}</div>
		</div>
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Industry Type</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{industry_type}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Address</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{company_address || address}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>State</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{state || user_state}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Postal Code</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{pincode}</div>
		</div>
    		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Language</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto">{language}</div>
		</div>
		{note && (
		<div className="flex border-b border-opacity-20 border-gray-300  ">
			<div className="w-32 px-2 py-3 sm:p-3">
				<p>Note</p>
			</div>
			<div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto" dangerouslySetInnerHTML={{ __html: note }}></div>
		</div>
		)}
	</div> 
</div>
    </div>
    <div className="col-span-2 row-span-4 col-start-5 bg-white row-start-3 p-4">
      <h2 className="text-xl font-semibold mb-3">Client Drivers</h2>
  <div className="">
    {/* Table Header */}
    <div className="flex bg-gray-50 font-medium border-b">
      <div className="w-1/3 px-3 py-2">Driver ID</div>
      <div className="w-2/3 px-3 py-2">Driver Name</div>
    </div>
    {/* Scrollable Table Body */}
    <div className="overflow-y-auto max-h-[300px]">
      {driversLoading ? (
        <div className="flex justify-center items-center py-8">
          <div className="text-gray-500">Loading drivers...</div>
        </div>
      ) : driversData.length > 0 ? (
        driversData.map((driver, index) => (
          <div key={index} className="flex border-b last:border-b-0 hover:bg-gray-50 text-sm">
            <div className="w-1/3 px-3 py-2 text-gray-600">{driver.user_id || driver.driverId}</div>
            <div className="w-2/3 px-3 py-2">{driver.username || driver.driverName || driver.name}</div>
          </div>
        ))
      ) : (
        <div className="flex justify-center items-center py-8">
          <div className="text-gray-500">No active drivers found</div>
        </div>
      )}
    </div>
  </div>
    </div>
    {/* <div className="col-span-2 row-span-4 col-start-5 bg-white row-start-7 p-4">
      <h2 className="text-xl font-semibold mb-3">Invoices</h2>
      <PieChart
  series={[
    {
      data: [ { id: 0, value: 10, label: 'Due' },
        { id: 1, value: 15, label: 'Unsettled' },
        { id: 2, value: 20, label: 'Paid' },],
      innerRadius: 40,
      outerRadius: 100,
      paddingAngle: 3,
      cornerRadius: 12,
      startAngle: -60,
      endAngle: 225,
      cx: 150,
      cy: 150,
    }
  ]}
/>
    </div> */}
<div className="col-span-2 row-span-4 col-start-5 bg-white row-start-7 p-4">
  <h2 className="text-xl font-semibold mb-2">Invoices</h2>
  <div className="flex flex-col justify-center items-center h-80">
    <div className="w-full h-60 mb-4">
      <ResponsivePie
        data={[
          {
            id: "due",
            label: "Due",
            value: due_invoice || 10,
            color: "#ff9800"
          },
          {
            id: "partial",
            label: "Partial",
            value: partial_invoice || 15,
            color: "#2196f3"
          },
          {
            id: "paid",
            label: "Paid",
            value: paid_invoice || 20,
            color: "#4caf50"
          }
        ]}
        margin={{ top: 10, right: 20, bottom: 50, left: 20 }}
        innerRadius={0.4}
        padAngle={2}
        cornerRadius={4}
        activeOuterRadiusOffset={6}
        borderWidth={1}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]]
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: 'color',
          modifiers: [['darker', 2]]
        }}
        colors={{ datum: 'data.color' }}
        theme={{
          tooltip: {
            container: {
              background: '#ffffff',
              color: '#333333',
              fontSize: '12px',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }
          },
          labels: {
            text: {
              fontSize: 10,
              fontWeight: 'bold'
            }
          }
        }}
        motionConfig="gentle"
        transitionMode="innerRadius"
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 45,
            itemsSpacing: 5,
            itemWidth: 50,
            itemHeight: 16,
            itemTextColor: '#333',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 10,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#000'
                }
              }
            ]
          }
        ]}
      />
    </div>
  </div>
</div>
</div>
    {/* Mobile Number Edit Dialog */}
    <Dialog
      open={openMobileEdit}
      onClose={handleCloseMobileEdit}
      aria-labelledby="mobile-edit-dialog-title"
      aria-describedby="mobile-edit-dialog-description"
      PaperProps={{
        sx: {
          marginTop: "30px",
          top: 0,
          position: "absolute",
          bgcolor: "#fff",
        },
      }}
    >
      <DialogTitle
        id="mobile-edit-dialog-title"
        sx={{
          bgcolor: "#1976d2",
          color: "#fff",
          textAlign: "center",
          width: "100%",
        }}
      >
        Update Mobile Number
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#fff", color: "#000", paddingTop: "20px" }}>
        <DialogContentText id="mobile-edit-dialog-description">
          <Grid container sx={{ padding: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Typography variant="p" gutterBottom style={{ color: "black", marginBottom: "10px" }}>
                Enter new mobile number (12 digits, starting with 91)<span style={{ color: "red" }}>*</span>
              </Typography>

              <TextField
                value={newMobileNumber}
                onChange={(e) => {
                  setNewMobileNumber(e.target.value);
                  setMobileError("");
                }}
                placeholder="Enter 12-digit mobile number starting with 91"
                variant="outlined"
                fullWidth
                error={!!mobileError}
                helperText={mobileError}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "black",
                    },
                    "&:hover fieldset": {
                      borderColor: "black",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "black",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "red",
                  },
                }}
              />
            </Box>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ bgcolor: "#fff", color: "#000", padding: "16px" }}>
        <Button
          onClick={handleCloseMobileEdit}
          variant="outlined"
          sx={{
            borderColor: "black",
            color: "black",
            "&:hover": {
              borderColor: "#1976d2",
              color: "#1976d2",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSaveMobile}
          variant="contained"
          sx={{
            bgcolor: "#1976d2",
            color: "#fff",
            "&:hover": {
              bgcolor: "#115293",
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>

    </>

  );
};

export default DetailsClients;
